import { useState } from "react";
import axios from "axios";
import { useCart } from "./context/CartContext";
import { useToast } from "./components/userToast";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./baseurl";

const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
  "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
  "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
  "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
  "New Hampshire", "New Jersey", "New Mexico", "New York",
  "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
  "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
  "West Virginia", "Wisconsin", "Wyoming",
];

export default function Checkout() {
  const { cartItems, updateQuantity, subtotal, clearCart } = useCart();
  const toast = useToast();
  const navigate = useNavigate();
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    address: "",
    apartment: "",
    city: "",
    postcode: "",
    country: "United States",
    state: "Nevada",
    useDifferentBilling: false,
    phone: "",
  });

  const [couponCode, setCouponCode] = useState("");
  const [showApartmentField, setShowApartmentField] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("bank");
  const [agreements, setAgreements] = useState({
    terms: false,
    newsletter: false,
    researchOnly: false,
  });

  const shippingCost = 8.0;
  const total = subtotal + shippingCost;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAgreementChange = (key) => {
    setAgreements((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handlePlaceOrder = async (e) => {
    e.preventDefault();

    if (!agreements.terms || !agreements.researchOnly) {
      toast({
        variant: "warning",
        title: "Checkboxes required",
        description: "Please accept the required checkboxes before placing your order.",
      });
      return;
    }

    if (cartItems.length === 0) {
      toast({
        variant: "error",
        title: "Cart is empty",
        description: "Add some items before checking out.",
      });
      return;
    }

    try {
      setIsPlacingOrder(true);

      const token = localStorage.getItem("token"); 

      const res = await axios.post(
        `${BASE_URL}/purchase/place-order`, 
        {
          formData,
          paymentMethod,
          agreements,
          cartItems,
          total,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast({
        variant: "success",
        title: "Order placed!",
        description: "We've received your order and sent a confirmation.",
      });

      clearCart?.(); 
      window.location.href="/order-success"; 
    } catch (error) {
      console.error("Place order error:", error);
      toast({
        variant: "error",
        title: "Order failed",
        description:
          error.response?.data?.message || "Something went wrong placing your order.",
      });
    } finally {
      setIsPlacingOrder(false);
    }
  };

  return (
    <div className="w-full bg-white">
      <div className="max-w-[1400px] mx-auto grid lg:grid-cols-2">
        <div className="px-6 md:px-16 py-12">
          <div className="flex justify-center mb-10">
            <div className="w-14 h-14 rounded-full bg-white border border-gray-200 flex items-center justify-center">
             
            </div>
          </div>

          <form onSubmit={handlePlaceOrder} className="flex flex-col gap-8 max-w-[560px] mx-auto">
            <div>
             <div className="flex flex-row justify-center items-center text-center">
             <div className="h-24 w-24 rounded-full overflow-hidden flex items-center justify-center bg-teal-500">
  <img 
    src="/logo.png" 
    alt="Futura Bio Labs" 
    className="w-full h-full object-cover"
  />
</div>
             </div>
              <h2 className="text-gray-800 font-semibold text-base mb-4 my-[3rem]">
                Contact Information
              </h2>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Email *"
                className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-teal-500"
              />
            </div>

            <div>
              <h2 className="text-gray-800 font-semibold text-base mb-4">
                Shipping Address
              </h2>

              <div className="flex flex-col gap-4">
                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    placeholder="First name *"
                    className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-teal-500"
                  />
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    placeholder="Last name *"
                    className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-teal-500"
                  />
                </div>

                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  placeholder="Street address *"
                  className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-teal-500"
                />
{!showApartmentField ? (
                  <button
                    type="button"
                    onClick={() => setShowApartmentField(true)}
                    className="text-teal-600 text-sm text-left flex items-center gap-1 hover:text-teal-700 w-fit"
                  >
                    <span className="font-semibold">+</span> Add Apartment, suite, unit, etc.
                  </button>
                ) : (
                  <input
                    type="text"
                    name="apartment"
                    value={formData.apartment}
                    onChange={handleChange}
                    autoFocus
                    placeholder="Apartment, suite, unit, etc."
                    className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-teal-500"
                  />
                )}
                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    placeholder="Town / City *"
                    className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-teal-500"
                  />
                  <input
                    type="text"
                    name="postcode"
                    value={formData.postcode}
                    onChange={handleChange}
                    required
                    placeholder="Postcode *"
                    className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-teal-500"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-500 text-xs mb-1">Country *</label>
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      required
                      className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 focus:outline-none focus:border-teal-500"
                    >
                      <option>United States (US)</option>
                     
                    </select>
                  </div>
                  <div>
  <label className="block text-gray-500 text-xs mb-1">State (optional)</label>
  <select
    name="state"
    value={formData.state}
    onChange={handleChange}
    required
    className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 focus:outline-none focus:border-teal-500"
  >
    {US_STATES.map((state) => (
      <option key={state} value={state}>
        {state}
      </option>
    ))}
  </select>
</div>
                </div>

              

                <div className="flex border border-gray-300 rounded-md overflow-hidden">
                  <div className="flex items-center gap-1 px-3 bg-gray-50 border-r border-gray-300 text-sm text-gray-700">
                    🇺🇸 +1
                  </div>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Phone"
                    className="flex-1 px-4 py-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none"
                  />
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-gray-800 font-semibold text-base mb-4">
                Shipping Method
              </h2>
              <div className="border border-teal-500 bg-teal-50 rounded-md px-4 py-3 flex items-center justify-between">
                <span className="text-gray-800 text-sm font-medium">Basic shipping</span>
                <span className="text-gray-800 text-sm font-medium">$8.00</span>
              </div>
            </div>

            {/* <div>
              <h2 className="text-gray-800 font-semibold text-base mb-4">Payment</h2>

              <div className="border border-gray-300 rounded-md overflow-hidden">
                <label
                  className={`flex items-center gap-3 px-4 py-3 cursor-pointer ${
                    paymentMethod === "bank" ? "bg-teal-50" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="payment"
                    checked={paymentMethod === "bank"}
                    onChange={() => setPaymentMethod("bank")}
                    className="accent-teal-500"
                  />
                  <span className="text-gray-800 text-sm font-medium">
                    Same-Day Bank Payment
                  </span>
                </label>

                {paymentMethod === "bank" && (
                  <div className="bg-gray-50 border-t border-gray-200 px-4 py-4 text-xs text-gray-600 leading-relaxed">
                    <p>
                      Pay with your US bank account through our secure gateway Link Money.
                      You'll be redirected to your bank to sign in and approve the payment.
                      Your credentials remain with your bank.
                    </p>
                    <p className="mt-2">
                      Same Day ACH: Payments usually clear within hours on business days.
                      If cleared before our cutoff we ship the same business day, otherwise
                      the next business day.
                    </p>
                    <ol className="list-decimal list-inside mt-2 flex flex-col gap-1">
                      <li>Use a US Checking account (Savings will reject ACH).</li>
                      <li>Ensure funds are available (returns incur a fee).</li>
                      <li>Your order ships as soon as the payment clears.</li>
                    </ol>

                    <label className="flex items-center gap-2 mt-4 cursor-pointer">
                      <input type="radio" name="bank-option" defaultChecked className="accent-teal-500" />
                      <span className="text-gray-800 font-medium">Link a new bank account</span>
                      <span className="ml-2 flex items-center gap-1 text-gray-400 text-[10px] font-semibold">
                        <span className="px-1.5 py-0.5 border border-gray-300 rounded">CHASE</span>
                        <span className="px-1.5 py-0.5 border border-gray-300 rounded">BofA</span>
                        <span className="px-1.5 py-0.5 border border-gray-300 rounded">WF</span>
                        & more
                      </span>
                    </label>
                  </div>
                )}

                <label
                  className={`flex items-center gap-3 px-4 py-3 border-t border-gray-200 cursor-pointer ${
                    paymentMethod === "zelle" ? "bg-teal-50" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="payment"
                    checked={paymentMethod === "zelle"}
                    onChange={() => setPaymentMethod("zelle")}
                    className="accent-teal-500"
                  />
                  <span className="text-gray-800 text-sm font-medium">Zelle</span>
                </label>

                <label
                  className={`flex items-center gap-3 px-4 py-3 border-t border-gray-200 cursor-pointer ${
                    paymentMethod === "venmo" ? "bg-teal-50" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="payment"
                    checked={paymentMethod === "venmo"}
                    onChange={() => setPaymentMethod("venmo")}
                    className="accent-teal-500"
                  />
                  <span className="text-gray-800 text-sm font-medium">Venmo</span>
                </label>
              </div>

              <p className="text-gray-400 text-xs mt-4">
                Your personal data will be used to process your order, support your
                experience throughout this website, and for other purposes described in
                our{" "}
                <a href="/privacy-policy" className="text-teal-600 hover:text-teal-700">
                  privacy policy
                </a>
                .
              </p>
            </div> */}

            <div className="flex flex-col gap-3">
              <label className="flex items-start gap-2 text-sm text-gray-600">
                <input
                  type="checkbox"
                  checked={agreements.terms}
                  onChange={() => handleAgreementChange("terms")}
                  required
                  className="mt-0.5 accent-teal-500"
                />
                <span>
                  I certify that I am 21 years of age or older and I have read and
                  agree to the website{" "}
                  <a href="/terms-and-conditions" className="text-teal-600 hover:text-teal-700">
                    terms and conditions
                  </a>{" "}
                  *
                </span>
              </label>

              

              <label className="flex items-start gap-2 text-sm text-gray-600">
                <input
                  type="checkbox"
                  checked={agreements.researchOnly}
                  onChange={() => handleAgreementChange("researchOnly")}
                  required
                  className="mt-0.5 accent-teal-500"
                />
                <span>
                  I acknowledge products are for in-vitro research only, NOT for human
                  consumption *
                </span>
              </label>
            </div>
            <button
              type="submit"
              disabled={
                isPlacingOrder ||
                cartItems.length === 0 ||
                !agreements.terms ||
                !agreements.researchOnly
              }
              className={`w-full flex items-center justify-center gap-2 font-semibold rounded-md py-4 transition-colors ${
                isPlacingOrder ||
                cartItems.length === 0 ||
                !agreements.terms ||
                !agreements.researchOnly
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-teal-500 hover:bg-teal-600 text-white"
              }`}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="11" width="14" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
                <path d="M8 11V7a4 4 0 118 0v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              {isPlacingOrder ? "Placing Order..." : `PLACE ORDER $${total.toFixed(2)}`}
            </button>
          </form>
        </div>

        <div className="bg-gray-50 px-6 md:px-16 py-12 border-t lg:border-t-0 lg:border-l border-gray-200">
          <div className="max-w-[440px] mx-auto lg:mx-0">
            <div className="flex flex-col gap-5 mb-6">
              {cartItems.length === 0 ? (
                <p className="text-gray-500 text-sm">Your cart is empty.</p>
              ) : (
                cartItems.map((item) => (
                  <div key={item.id} className="flex items-center gap-4">
                    <div className="relative w-14 h-14 bg-white border border-gray-200 rounded-md flex items-center justify-center flex-shrink-0">
                      <span className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-gray-400 text-white text-[10px] flex items-center justify-center">
                        {item.quantity}
                      </span>
                      {item.image ? (
                        <img src={item.image} alt={item.name} className="w-full h-full object-cover rounded-md" />
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-gray-300" xmlns="http://www.w3.org/2000/svg">
                          <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
                          <circle cx="9" cy="9" r="1.5" fill="currentColor" />
                          <path d="M21 15l-5-5-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      )}
                    </div>

                    <div className="flex-1">
                      <p className="text-gray-800 text-sm font-medium">{item.name}</p>
                      <div className="flex items-center border border-gray-300 rounded-full mt-1.5 w-fit">
                        <button
                          onClick={() => updateQuantity(item.id, -1)}
                          className="w-6 h-6 flex items-center justify-center text-gray-600 hover:text-teal-600 text-xs"
                        >
                          −
                        </button>
                        <span className="w-6 text-center text-xs text-gray-800">
                          {item.quantity}
                        </span>
                        <button
                          onClick={() => updateQuantity(item.id, 1)}
                          className="w-6 h-6 flex items-center justify-center text-gray-600 hover:text-teal-600 text-xs"
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <p className="text-gray-800 text-sm font-medium">
                      ${(item.price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                ))
              )}
            </div>

            

            <div className="border-t border-gray-200 pt-4 flex flex-col gap-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Subtotal</span>
                <span className="text-gray-800 font-medium">${subtotal.toFixed(2)}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Shipping</span>
                <span className="text-gray-800 font-medium">${shippingCost.toFixed(2)}</span>
              </div>
            </div>

            <div className="border-t border-gray-200 mt-4 pt-4 flex items-center justify-between">
              <span className="text-gray-800 font-semibold text-base">Total</span>
              <span className="text-teal-600 font-semibold text-lg">
                ${total.toFixed(2)}
              </span>
            </div>

            <div className="mt-10">
              <h3 className="text-gray-800 font-semibold text-sm mb-5">
                Why Researchers Trust Futura
              </h3>

              <div className="flex flex-col gap-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-teal-50 flex items-center justify-center">
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" className="text-teal-500" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 6h11v9H3V6zm11 3h4l3 3v3h-7V9zM6.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 text-sm font-medium">Express Shipping</p>
                    <p className="text-gray-500 text-xs mt-1">
                      Ships in 1-2 business days. Orders placed on weekends ship the
                      following Monday.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-teal-50 flex items-center justify-center">
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" className="text-teal-500" xmlns="http://www.w3.org/2000/svg">
                      <rect x="5" y="4" width="14" height="17" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
                      <path d="M9 9l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 text-sm font-medium">Secured Payment</p>
                    <p className="text-gray-500 text-xs mt-1">
                      Safe, encrypted checkout every time to protect your information.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-teal-50 flex items-center justify-center">
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" className="text-teal-500" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.5" />
                      <path d="M5 20a7 7 0 0114 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 text-sm font-medium">24/7 Support</p>
                    <p className="text-gray-500 text-xs mt-1">
                      Our team is here whenever you need us. We respond within 24 hours.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}